require('expose-loader?exposes=jQuery,$!jquery');
require('expose-loader?exposes=MicroModal!micromodal');
require('slick-carousel');
